export default "Optimisation TURPE patrimoine public — Bâtiments & éclairage | Solution Éco France";
